import  React from 'react';
import styled from 'styled-components';
import { Link, withRouter } from 'react-router-dom';
import { LogoGreen} from '../components/images';


const SideView = styled.div`
  overflow-x: hidden; 
  overflow-y: auto; 
  margin: 0;
  padding: 0;
  width: 100%;
  width: 200px;
  background-color: #D7EBEB;
  position: fixed;
  height: 100%;
  text-transform:uppercase;
  a{
  display: block;
  color: #005A4B;
  padding: 16px;
  text-decoration: none;
  }
  a:active{
  background-color: #F0F0F0;
  color: green;
  }
  a:hover:not(.active) {
  background-color: #F0F0F0;
  color: #005A4B;
}

@media screen and (max-width: 700px) {
    width: 100%;
    height: auto;
    position: relative;
  a {float: left;}
}

@media screen and (max-width: 400px) {
  a {
    text-align: center;
    float: none;
  }
}
`;

   
const StyledLogo = styled.div`
position: relative;
padding-left: 42px;
margin: 4px;
img{
    width: 100%;
    height: auto;
    max-width:90px;
}


`;

const Info = styled.div`
padding: 20px;
margin-bottom: 3em;
font-size:20px;

h1{
    font-size:20px;
    font-style:bold;
    color: #005A4B;
}

@media screen and (max-width: 600px) {
  
  width: 100%;
  height: auto;
  position: relative;
  float: left;
div.content {margin-left: 0;}
}
`;
const StyledLink = styled.div`
 margin-top: 2em;
`;

class Sidebar extends React.Component {
  constructor(props){
    super(props); 
         
    this.routeChange = this.routeChange.bind(this);
}
routeChange() {
    let path = `/`;
    // eslint-disable-next-line react/prop-types
    this.props.history.push(path);
}
  render() {
    return (
        <SideView>
            <Info>
            <h1>information</h1>
            <StyledLogo  onClick={()=>{ this.routeChange()}}>
            <LogoGreen>
            </LogoGreen>
            </StyledLogo>
            </Info>
            <Link to='/tider'>öppetider</Link>
            <Link to='/mat'>matsedel</Link>
            <Link to='/private'>personligt</Link>
           <StyledLink> <Link to='/'>Tillbaka</Link></StyledLink> 
        </SideView>
    )

  }
}

export default withRouter (Sidebar);

